import React, { Component, Fragment } from "react";
import { DropTarget } from "react-dnd";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap";
import ItemTypes from "./ItemTypes";
import Materialicon from "../../helpers/Materialicon";
import InlineError from "../../messages/InlineError";


const areasTarget = {
	drop(targetProps, monitor) {
		targetProps.dropedNewArea(monitor.getItem());
		monitor.isOver();
	},
};

class AreaTarget extends Component {

	render() {
		const { isOver, connectDropTarget, areas, onChangeAreaValue, removeNewArea, errors } = this.props;
		return connectDropTarget(
			<div>
				<div className={`assigned-skills ${errors.areas_error ? "error" : ""} ${isOver ? "is-droping" : ""}`}>
					{(Array.isArray(areas) && areas.length > 0) ?
						<Fragment>
							{areas.map((item, index) => (
								<div className="item-area" key={item.id}>
									<div><label htmlFor={`area-${item.id}`}>{item.name}</label> <button onClick={() => removeNewArea(item, index)} className="btn pull-right btn-remove-dnd"> <Materialicon icon="close" /></button></div>
									<div>
										<input
											type="number"
											step="0.1"
											id={`area-${item.id}`}
											className="form-control"
											name={`area-${item.id}`}
											value={item.value}
											onChange={(e) => onChangeAreaValue(e, item, index)}
											placeholder="Enter value"
										/>
									</div>
								</div>
							))}
						</Fragment>
						:
						<h4 className="text-center"> Drag areas here! </h4>
					}
				</div>
				{errors.areas_error && <div className="alert alert-danger" role="alert">{errors.areas_error}</div>}
			</div>
		);
	}
}
const area = {
	name: PropTypes.string,
	value: PropTypes.number,
	id: PropTypes.number
};

AreaTarget.defaultProps = {
	errors: PropTypes.object,
};

AreaTarget.propTypes = {
	errors: PropTypes.shape({
		areas_error: PropTypes.string,
	}),
	isOver: PropTypes.bool.isRequired,
	connectDropTarget: PropTypes.func.isRequired,
	onChangeAreaValue: PropTypes.func.isRequired,
	removeNewArea: PropTypes.func.isRequired,
	areas: PropTypes.arrayOf(PropTypes.shape(area)).isRequired
};

const collect = (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
});

export default DropTarget(ItemTypes.AREA, areasTarget, collect)(AreaTarget);



// WEBPACK FOOTER //
// ./src/components/partials/areas/AreaTarget.js